(function () {
  var banner = document.querySelector('.banner__media img, .banner__media video');
  if (!banner) return;

  var wrapper = banner.closest('.banner__media');
  if (!wrapper) return;

  // Ensure overflow hidden on the container
  wrapper.style.overflow = 'hidden';
  banner.style.willChange = 'transform';
  banner.style.transition = 'transform 0.05s linear';

  var ticking = false;

  function update() {
    var rect = wrapper.getBoundingClientRect();
    var viewH = window.innerHeight;
    // Only animate when banner is in view
    if (rect.bottom < 0 || rect.top > viewH) { ticking = false; return; }

    // scroll progress from -1 (banner above viewport) to 1 (below)
    var progress = (viewH - rect.top) / (viewH + rect.height);
    // Shift image max ±20px
    var offset = (progress - 0.5) * 40;
    banner.style.transform = 'translateY(' + offset + 'px) scale(1.05)';
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  update();
})();
